// timer.component.ts

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonService} from "../../services/common.service";

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css']
})
export class TimerComponent implements OnInit {
  @Input() timerDuration: number = 30;
  @Output() handleTimerComplete: EventEmitter<void> = new EventEmitter<void>();

  timeLeft: number = 30;
  timerInterval: any;
  timerValue = ''

  constructor(
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.resetTimer();
    this.startTimer();
  }

  startTimer() {
    this.timerInterval = setInterval(() => {
      this.timeLeft--;

      this.timerValue = this.commonService.convertSecondsToMinutesAndSeconds(this.timeLeft);

      if (this.timeLeft === 0) {
        this.handleTimerComplete.emit();
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  resetTimer() {
    this.timeLeft = this.timerDuration;
  }



  ngOnDestroy() {
    // Clear the interval to avoid memory leaks
    clearInterval(this.timerInterval);
  }
}
